export class Cache {
  private cache: Map<string, { expires: number; value: Promise<any> }>;
  constructor() {
    this.cache = new Map();
  }
  getOrProduce(key: string, producer: () => Promise<any>, ttl: number = 5 * 60 * 1000): Promise<any> {
    const cached = this.cache.get(key);
    if (cached && cached.expires > Date.now()) {
      return cached.value;
    }
    const value = producer();
    this.cache.set(key, { expires: Date.now() + ttl, value });
    return value;
  }
}